{
	"backToStartPage": "Επιστροφή στην αρχική σελίδα",
	"transactionDetailsTitle": "Στοιχεία συναλλαγής",
	"btnVerifyTransactions": "Επαλήθευση συναλλαγών",
	"kpi": {
		"date": "Ημερομηνία",
		"quantity": "Ποσότητα",
		"carbonReductions": "Μειώσεις άνθρακα"
	},
	"verifyTransactionModal": {
		"title": "Επαλήθευση συναλλαγής",
		"description": "Εισαγάγετε το αναγνωριστικό εγγραφής για αυτήν τη συναλλαγή. Μπορείτε να βρείτε τις πληροφορίες στη δήλωση.",
		"recordIdLabel": "Ταυτότητα εγγραφής",
		"cancelTitle": "Ματαίωση",
		"verifyTitle": "Επαληθεύω",
		"errors": {
			"recordIdRequired": "Απαιτείται αναγνωριστικό εγγραφής",
			"recordIdInvalid": "Το αναγνωριστικό εγγραφής πρέπει να αποτελείται από 16 χαρακτήρες (γράμματα ή αριθμούς), με μορφή ABCD 1234 EFGH 5678",
			"verificationFailed": "Δεν ήταν δυνατή η επαλήθευση της συναλλαγής. Ελέγξτε το αναγνωριστικό εγγραφής"
		}
	},
	"errors": {
		"notFound": "Η συναλλαγή δεν βρέθηκε"
	}
}
